<template>
  <div class="login">
    <header>
      <div class="logo">
        <img src="../assets/logo_black.png" alt="">
      </div>
      <div class="operation">
        <router-link to="/">返回首页</router-link>
      </div>
    </header>
    <section>
      <div class="content">
        <div class="l">
          <img src="../assets/icon_login_bg.png" alt="">
        </div>
        <div class="r" v-if="page == 0">
          <p class="title">{{loginType == 0 ? '账号登录' : '验证码登录'}}</p>
          <div class="from-item">
            <p> {{loginType == 0 ? '账号' : '手机号'}}</p>
            <div class="input"><input type="text" v-model="param.account" placeholder="请输入手机号" /></div>
          </div>
          <!-- 图形验证码 -->
          <div class="from-item" >
            <p>图形验证码</p>
            <div class="input">
              <input type="text" v-model="param.imgCode" placeholder="请输入图形验证码" />
              <img :src="verifyImg" alt="点击刷新" @click="refresh2" style="cursor: pointer; position: absolute; right: 0; top: 0; height: 100%;" />
            </div>
          </div>
          <div class="from-item">
            <p>{{loginType == 0 ? '登录密码' : '验证码'}}</p>
            <div  class="input">
              <span v-if="loginType == 1" @click="_getSmsCode" class="click">{{countDown === -1 ? '获取验证码' : countDown + 's'}}</span>
              <input type="password" v-model="param.password" :placeholder="'请输入' + (loginType == 0 ? '密码' : '验证码')"/>
            </div>
          </div>
          <div class="func">
            <div></div>
            <div>
              <span class="click" @click="_switchLoginType">{{loginType == 0 ? '验证码登录': '密码登录'}}</span>
            </div>
          </div>
          <div class="btn">
            <button class="click" @click="_login">登录</button>
          </div>
          <p class="reg">
            没有账号？<router-link to="/register">马上注册</router-link>
          </p>
        </div>
        <div class="r" v-if="page == 1">
          <p class="title">注册账号</p>
          <div class="desc">请使用微信扫描二维码，识别后前往注册！</div>
          <div class="code">
            <div v-if="codeStatus < 0" class="overdue">
              <p>{{ codeStatus === -1 ? '二维码已过期': '操作失败' }}</p>
              <button class="click" @click="_getWxCode">点我刷新</button>
            </div>
            <img v-if="codeStatus === 0" :src="code" alt="">
            <img class="s" v-if="codeStatus === 1" src="../assets/success.png" alt="">
          </div>
          <p class="reg">
            已有账号？<span class="click" @click="_switchPageType">马上登录</span>
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getSmsCode, loginByPwd, loginByCode, getMiniCode, getMiniCodeProgress, CAPTCHA_URL } from '../service/getData'

const captchaUrl = CAPTCHA_URL
// 腾讯验证码配置 - 请替换为您的实际 CaptchaAppId
const TENCENT_CAPTCHA_APP_ID = '198608012'

export default {
  name: 'login',
  data () {
    return {
      loginType: 0,
      page: 0,
      countDown: -1,
      sendCodeCount: 0,
      code: '',
      codeStatus: 0,
      uid: '',
      iv: null,
      param: {
        account: null,
        password: null,
        token: null,
        scene: 'register',
        sessionId: null,
        sig: null,
        imgCode: null
      },
      verifyImg: captchaUrl,
      timestamp: null,
      // 腾讯验证码相关
      tencentCaptchaReady: false,
      tencentCaptcha: null
    }
  },
  created () {
    this.refresh2()
    if (this.$route.query.page) {
      this.page = this.$route.query.page
    }
    this.loadTencentCaptchaScript()
  },
  mounted () {
    if (this.page === 0) {
      this.initAliCheck()
    } else {
      this._getWxCode()
    }
  },
  methods: {
    /**
     * 初始化阿里验证码（已注释，保留空函数防止报错）
     */
    initAliCheck () {
      // 阿里滑块已废弃，无需实现

    },
    refresh2 () {
      this.timestamp = new Date().getTime()
      this.verifyImg = `${captchaUrl}?t=${this.timestamp}`
    },

    // ========== 腾讯验证码接入 ==========
    loadTencentCaptchaScript () {
      if (document.querySelector('#tencent-captcha-script')) {
        this.tencentCaptchaReady = true
        this.initTencentCaptcha()
        return
      }
      const script = document.createElement('script')
      script.id = 'tencent-captcha-script'
      script.src = 'https://turing.captcha.qcloud.com/TJCaptcha.js'
      script.onload = () => {
        this.tencentCaptchaReady = true
        this.initTencentCaptcha()
      }
      script.onerror = () => {
        console.error('腾讯验证码脚本加载失败')
        this.tencentCaptchaReady = false
      }
      document.head.appendChild(script)
    },
    initTencentCaptcha () {
      if (window.TencentCaptcha && !this.tencentCaptcha) {
        this.tencentCaptcha = new window.TencentCaptcha(TENCENT_CAPTCHA_APP_ID, (res) => {
          if (res.ret === 0) {
            // 验证成功，调用短信发送接口
            this.sendSmsWithTicket(res.ticket, res.randstr)
          } else if (res.ret !== 2) {
            this.$message.error('人机验证失败，请重试')
          }
        }, { userLanguage: 'zh-cn' })
      }
    },
    async sendSmsWithTicket (ticket, randstr) {
      if (this.countDown !== -1) return
      this.countDown = 120
      this.sendCodeCount += 1
      try {
        const res = await getSmsCode(this.param.imgCode, this.param.account, ticket, randstr, this.timestamp)
        if (res.code === 1) {
          const timer = setInterval(() => {
            if (this.countDown <= 0) {
              clearInterval(timer)
              this.countDown = -1
            } else {
              this.countDown -= 1
            }
          }, 1000)
        } else {
          this.countDown = -1
          this.sendCodeCount = 0
          this.$message.error(res.msg)
          this.refresh2()
        }
      } catch (err) {
        this.countDown = -1
        this.sendCodeCount = 0
        this.$message.error('发送失败，请重试')
        console.error(err)
      }
    },

    /**
     * 登录
     */
    async _login () {
      if (this.loginType === 0) {
        if (this.$verify.empty(this.param.account)) { this.$message.error('请输入账号'); return false }
      } else {
        if (!this.$verify.phone(this.param.account)) { this.$message.error('请输入正确的手机号码'); return false }
      }
      if (this.loginType === 1) {
        if (this.sendCodeCount === 0) { this.$message.error('请点击按钮获取验证码'); return false }
      }
      if (this.$verify.empty(this.param.password)) { this.$message.error('请输入' + (this.loginType === 0 ? '密码' : '验证码')); return false }
      const hide = this.$message.loading('正在登录', 0)
      var res = null
      if (this.loginType === 0) {
        res = await loginByPwd(this.param)
      } else {
        res = await loginByCode(this.param)
      }
      if (res.code === 1) {
        window.localStorage.setItem('token', res.data.token)
        this.$store.dispatch('getUserInfo')
        hide()
        this.$router.push({ name: 'Home' })
      } else {
        this.$message.error(res.msg)
        hide()
      }
    },

    /**
     * 切换登录方式
     */
    _switchLoginType () {
      this.loginType = this.loginType === 1 ? 0 : 1
      if (this.loginType === 1) {
        this.param.password = ''
      }
    },

    /**
     * 选择界面
     */
    _switchPageType () {
      var _this = this
      if (_this.page === 0) {
        _this.page = 1
        _this._getWxCode()
      } else {
        if (_this.iv !== null) {
          clearInterval(_this.iv)
          _this.code = ''
        }
        _this.page = 0
        _this.$nextTick(() => {
          // 阿里滑块已废弃，无需初始化
        })
      }
    },

    /**
     * 获取微信二维码进度
     */
    getWxCodeProgress () {
      var _this = this
      var time = new Date().getTime() / 1000
      var func = async () => {
        var res = await getMiniCodeProgress(_this.uid)
        if (res.code === 1) {
          if (res.data === 1) {
            _this.codeStatus = 1
            if (this.iv !== null) {
              clearInterval(this.iv)
            }
          } else if (res.data === 0) {
            _this.codeStatus = -2
            if (this.iv !== null) {
              clearInterval(this.iv)
            }
          }
        }
        if (new Date().getTime() / 1000 - time > 300) {
          _this.codeStatus = -1
          if (this.iv !== null) {
            clearInterval(this.iv)
          }
        }
      }
      func()
      this.iv = setInterval(func, 3000)
    },

    /**
     * 获取小程序二维码
     */
    async _getWxCode () {
      this.code = ''
      this.codeStatus = 0
      var res = await getMiniCode({ page: 'pages/register/register', scene: 'a=1' })
      if (res.code === 1) {
        this.code = res.data.image
        this.uid = res.data.uid
        this.getWxCodeProgress()
      }
    },

    /**
     * 获取验证码（新流程：先弹出腾讯验证码）
     */
    async _getSmsCode () {
      // 1. 校验手机号
      if (!this.$verify.phone(this.param.account)) {
        this.$message.error('请输入正确的手机号码')
        return false
      }
      // 2. 校验图形验证码
      if (this.$verify.empty(this.param.imgCode)) {
        this.$message.error('请输入图形验证码')
        return false
      }
      if (this.param.imgCode.length !== 5) {
        this.$message.error('图形验证码长度应为5位')
        return false
      }
      // 3. 倒计时中不可获取
      if (this.countDown !== -1) return

      // 4. 确保腾讯验证码已加载
      if (!this.tencentCaptchaReady || !this.tencentCaptcha) {
        this.$message.error('验证码组件未就绪，请刷新页面重试')
        return
      }

      // 5. 弹出腾讯验证码
      this.tencentCaptcha.show()
    }
  },

  destroyed () {
    if (this.iv !== null) {
      clearInterval(this.iv)
    }
  }
}
</script>


<style lang="scss">
@import "../style/mixin";
.login {
  position: relative;
  width: 100%;
  height: 100%;
  section {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    &::after {
      content: ' ';
      @include ct;
      background-color: #CEE5F9;
      width: 100%;
      height: 2.917rem;
    }
    .content {
      width: 9.392rem;
      height:6.675rem;
      background:rgba(255,255,255,1);
      border-radius: 0.1rem;
      @include center;
      z-index: 2;
      box-shadow:0rem 0.1rem 0.2rem 0rem rgba(14,37,61,0.26);
      display: flex;
      position: relative;
      &::after {
        position: absolute;
        content:  ' ';
        top: 0;
        bottom: 0;
        width: 1px;
        left: 50%;
        background-color: #EEEEEE;
      }
      &>div {
        flex: 1;
      }
      .r {
        text-align: center;
        &>div {
          padding: 0 0.275rem;
        }
        .code {
          width: 1.958rem;
          height: 1.958rem;
          margin: 0 auto;
          margin-top: 0.5rem;
          padding: 0;
          text-align: center;
          line-height: 1.958rem;
          position: relative;
          .overdue {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            line-height: 1;
            font-size: 0.233rem;
            font-family: PingFang SC;
            font-weight: bold;
            background-color: #f5f5f5;
            p {
              margin-top: 0.6rem;
            }
            button {
              background-color: transparent;
              color: #576b95;
              margin-top: 0.317rem;
            }
          }
          .s {
            width: 60%;
            height: 60%;
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
        .desc {
          font-size: 0.15rem;
          font-family: PingFang SC;
          font-weight: bold;
          margin-top: 0.917rem;
        }
        .reg {
          margin-top: 0.14rem;
          font-size: 0.15rem;
          color: #999999;
          span {
            color: #3B97E5;
          }
        }
        .btn {
          font-size: 0.2rem;
          font-family: PingFang SC;
          font-weight: 500;
          margin-top: 0.252rem;
          button {
            display: block;
            width: 100%;
            background: rgba(59,151,229,1);
            line-height: 0.542rem;
            height: 0.542rem;
            color: #fff;
            box-shadow:0rem 0.1rem 0.1rem 0rem rgba(10,13,47,0.05);
            border-radius: 0.083rem;
          }
        }
        .alicheck {
          height: 0.542rem;
          #nc {
            line-height: 0.542rem;
            height: 100%;
            ._nc {
              .stage {
                padding: 0;
              }
              .stage1 {
                height: 100%;
                .track {
                  div {
                    line-height: 0.542rem;
                    height: 100%;
                    font-size: 0.15rem;
                  }
                }
                .button {
                  height: 100%;
                }
                .slider {
                  left: 0;
                  right: 0;
                  height: 100%;
                  .label {
                    height: 100%;
                    line-height: 0.542rem;
                    font-size: 0.15rem;
                  }
                }
              }
            }
          }
        }
        .func {
          display: flex;
          line-height: 0.532rem;
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 0.15rem;
          &>div {
            flex: 1;
            &:first-child {
              text-align: left;
              color: #999999;
              input {
                margin-right: 0.083rem;
                vertical-align: middle;
                margin-bottom: 2px;
              }
            }
            &:last-child {
              text-align: right;
              span {
                color: #3B97E5;
              }
            }
          }
        }
        .title {
          font-size: 0.233rem;
          margin-top: 0.317rem;
          font-family: PingFang SC;
          font-weight: bold;
        }
        .from-item {
          margin-top: 0.273rem;
          text-align: left;
          p {
            font-size: 0.15rem;
            font-family: PingFang SC;
            font-weight: 500;
            color: #000;
            line-height: 0.267rem;
          }
          .input {
            border-radius: 0.083rem;
            border: 1px solid #EEEEEE;
            height: 0.542rem;
            line-height: 0.542rem;
            overflow: hidden;
            margin-top: 0.168rem;
            position: relative;
            span {
              position: absolute;
              right: 0;
              background-color: #3B97E5;
              padding: 0 0.367rem;
              color: #FFFFFF;
              font-size: 0.15rem;
            }
            input {
              padding: 0 0.167rem;
              height: 100%;
              width: 100%;
              outline: none;
            }
          }
        }
      }
      .l {
        text-align: center;
        img {
          margin-top: 0.867rem;
          @include wh(4.017rem, 3.742rem)
        }
      }
    }
  }
  header {
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 0.75rem;
    font-size: 0.15rem;
    border-bottom: 0.008rem solid #EEEEEE;
    .logo {
      img {
        width: 2.5rem;
      }
    }
    .operation {
      a {
        color: #333333;
        font-family: PingFang SC;
        font-weight: 500;
      }
    }
    &>div {
      flex: 1
    }
  }
}
</style>
